module.exports = __webpack_public_path__ + "img/cloudenly_logo.401ea95f.svg";